import {
    CREATE_ACCESSORIES_INWARD_FAILURE_DK,
    CREATE_ACCESSORIES_INWARD_REQUEST_DK,
    CREATE_ACCESSORIES_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_ACCESSORIES_INWARD_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_INWARD_SUCCESS_DK,
    FETCH_ACCESSORIES_INWARD_FAILURE_DK,
    FETCH_ACCESSORIES_INWARD_REQUEST_DK,
    FETCH_ACCESSORIES_INWARD_SUCCESS_DK,
    NAVIGATE_ACCESSORIES_INWARD_DETAILS_DK,
    NAVIGATE_ACCESSORIES_INWARD_DK,
    ACCESSORIES_INWARD_USERFORM_RESET_DK,
    UPDATE_ACCESSORIES_INWARD_FAILURE_DK,
    UPDATE_ACCESSORIES_INWARD_REQUEST_DK,
    UPDATE_ACCESSORIES_INWARD_SUCCESS_DK,
    DELETE_ACCESSORIES_INWARD_REQUEST_DK,
    DELETE_ACCESSORIES_INWARD_SUCCESS_DK,
    DELETE_ACCESSORIES_INWARD_FAILURE_DK,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_ACCESSORIES_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_ACCESSORIES_INWARD_ID_DK,
    FETCH_ACCESSORIES_INWARD_STYLE_REQUEST_DK,
    FETCH_ACCESSORIES_INWARD_STYLE_SUCCESS_DK,
    FETCH_ACCESSORIES_INWARD_STYLE_FAILURE_DK
} from './accessoriesInward.actionsType';

export const ACCESSORIES_INWARD_DK = 'accessoriesInwardDK';

let initialState = {
    loading: false,
    accessoriesInward: [],
    pendingAccessoriesInward: [],
    AccessoriesPOInwardStyleList: [],
    activeKey: 1,
    accessoriesInwardId: '',
    accessoriesInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    isAccessoriesInward: false,
    accessoriesInwardSelectedValue: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let accessoriesInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_INWARD_REQUEST_DK:
        case FETCH_ACCESSORIES_INWARD_STYLE_REQUEST_DK:
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST_DK:
        case CREATE_ACCESSORIES_INWARD_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_INWARD_REQUEST_DK:
        case UPDATE_ACCESSORIES_INWARD_REQUEST_DK:
        case DELETE_ACCESSORIES_INWARD_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInward: updatePayload
            };
            case FETCH_ACCESSORIES_INWARD_STYLE_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    AccessoriesPOInwardStyleList: updatePayload?.PONO
                };
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingAccessoriesInward: updatePayload
            };
        case CREATE_ACCESSORIES_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                accessoriesInwardId: updatePayload[0]?.fldID,
                activeKey: updatePayload[0]?.fldID && payload ? 2 : 1
            };
        case FETCH_SINGLE_ACCESSORIES_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                accessoriesInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_ACCESSORIES_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                accessoriesInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case DELETE_ACCESSORIES_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case FETCH_ACCESSORIES_INWARD_FAILURE_DK:
        case FETCH_ACCESSORIES_INWARD_STYLE_FAILURE_DK:
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_INWARD_FAILURE_DK:
        case CREATE_ACCESSORIES_INWARD_FAILURE_DK:
        case UPDATE_ACCESSORIES_INWARD_FAILURE_DK:
        case DELETE_ACCESSORIES_INWARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_INWARD_DK:
            return {
                ...state,
                loading: false,
                accessoriesInwardForm: {
                    ...state.accessoriesInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_ACCESSORIES_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case ACCESSORIES_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                accessoriesInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {},
                accessoriesInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_ACCESSORIES_INWARD_ID_DK:
            return {
                ...state,
                accessoriesInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_ACCESSORIES_INWARD_DETAILS_DK:
            return {
                ...state,
                isAccessoriesInward: true,
                accessoriesInwardSelectedValue: updatePayload.accessoriesInwardSelectedValue
            };
        case NAVIGATE_ACCESSORIES_INWARD_DK:
            return {
                ...state,
                isAccessoriesInward: false
            };
        default:
            return state;
    }
};
